import Image, { StaticImageData } from 'next/image';
import nmcLogo from '../assets/nmc.png';
import careQualityLogo from '../assets/care-quality.png';
import scopeLogo from '../assets/scope.png';
import cpdLogo from '../assets/cpd.png';
import hamiltonLogo from '../assets/hamilton.png';

interface Certification {
  id: number;
  name: string;
  description: string;
  logo: StaticImageData;
  width?: string;
}

const certifications: Certification[] = [
  {
    id: 1,
    name: "NMC",
    description: "Nursing & Midwifery Council",
    logo: nmcLogo,
  },
  {
    id: 2,
    name: "Care Quality Commission", 
    description: "Inspected and rated by",
    logo: careQualityLogo,
  },
  {
    id: 3,
    name: "SCOPE",
    description: "Accredited",
    logo: scopeLogo, 
  },
  {
    id: 4,
    name: "CPD",
    description: "Certified - The CPD Certification Service",
    logo: cpdLogo,
  },
  {
    id: 5,
    name: "Hamilton Fraser",
    description: "Cosmetic Insurance",
    logo: hamiltonLogo,
  }
];

interface CertificationsSectionProps {
  isHomePage?: boolean;
}

export default function CertificationsSection({ isHomePage = false }: CertificationsSectionProps) {
  const paddingClasses = isHomePage 
    ? "py-8 sm:py-12" 
    : "py-6 sm:py-8";

  return (
    <section className={`${paddingClasses} bg-gray-50 border-t border-gray-200`}>
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-5 sm:grid-cols-3 md:grid-cols-5 gap-4 sm:gap-6 lg:gap-8 items-center justify-items-center">
          {certifications.map((cert) => (
                <Image
                  key={cert.id}
                  src={cert.logo}
                  alt={`${cert.name} logo`}
                  width={250}
                  height={200}
                  className="object-contain w-[80px] sm:w-[200px] sm:h-full"
                />
          ))}
        </div>
      </div>
    </section>
  );
}
